import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient}from '@angular/common/http';
import { Csp5050Class } from '../../CSPClass/CSP5050/csp5050-class';
import { environment } from '../../../../../../../src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class Csp5050Service {
  baseUrl: string=  environment.baseUrlCsp + 'CSP5050/';
  constructor(private http:HttpClient) { }

     PaidFee(Csp5050Class:Csp5050Class):Observable<any>
       {
          return this.http.post<any>(this.baseUrl+'PaidFee',Csp5050Class);
      }
  
}
